import React, { useState, useEffect } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { getHomepage } from '../services/api';

const Home = () => {
  const [homepage, setHomepage] = useState(null);

  useEffect(() => {
    fetchHomepage();
  }, []);

  const fetchHomepage = async () => {
    try {
      const response = await getHomepage();
      setHomepage(response.data);
      //console.log('homepage:', response.data);
    } catch (error) {
      console.error('Failed to fetch homepage:', error);
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        {homepage ? (
          <>
            <div dangerouslySetInnerHTML={{ __html: homepage.html }} />
          </>
        ) : (
          <Typography variant="h4" component="h1" gutterBottom>
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default Home;